module.exports = __webpack_public_path__ + "static/media/YM34_1.1bce19be.jpg";